<template>
  <div id="configuracoes-dashboard"
    v-if="mostrar_tela"
    style="display: block;" 
    class="w3-modal"
    v-cloak>
    
    <div class="w3-main w3-animate-left w3-margin-bottom w3-padding w3-modal-content" style="margin-top: 0px;">
      <header class="w3-container" style="padding-top:0px; padding: 0px;">
        <span
          @click="mostrar_tela = false"
          class="w3-button w3-display-topright w3-text-theme w3-large">
          &times;
        </span>
        <h5><b><i class="fa fa-cog"></i>  Configurações</b></h5>
      </header>

      <div class="w3-block w3-row-padding">
        <div class="w3-col s12 m12 l12 w3-margin-bottom" v-if="!configuracoes_financeiro_totalmente_carregado">
          <div class="w3-panel w3-theme w3-card-2">
            <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
          </div>
        </div>
      </div><!-- w3-block -->
      
      <div class="w3-block w3-row" v-if="configuracoes_financeiro_totalmente_carregado">
        <div class="w3-container">
          <header >
            <h4 class="titulo texto-vermelho">Dashboard</h4>
          </header>

          <div class="w3-block w3-row">
            <div class="w3-col l4" style="margin-top: 0px">
              <h5><b><i class="fa fa-shopping-cart"></i>  Vendas</b></h5>
              
              <button
                v-if="(
                  (!ativar_todos_vendas) &&
                  (
                    permitirVisualizarPedidosBloqueados() || 
                    permitirVisualizarPedidosVencendo() ||
                    permitirVisualizarProdutosEmPromocao() ||
                    permitirVisualizarProdutosEmPontaEstoque() || 
                    permitirVisualizarProdutosCadastrado30Dias() ||
                    permitirVisualizarProdutosComissaoEspecial() ||
                    permitirVisualizarDadosVendas()
                  )
                )"
                @click="ativarVendas()" 
                class="w3-button w3-green w3-round-xxlarge w3-margin-bottom">
                <i class="fas fa-check"></i> Ativar todos
              </button>

              <button 
                v-if="ativar_todos_vendas"
                @click="desativarVendas()"
                class="w3-button w3-red w3-round-xxlarge w3-margin-bottom">
                <i class="fas fa-times"></i> Desativar todos
              </button>
              
              <div class="checkbox-group">
                <input
                  type="checkbox"
                  class="switch-input" 
                  id="pedidos-bloqueados" 
                  :change="verificarSwitchVendas()" 
                  :disabled="!permitirVisualizarPedidosBloqueados()"
                  v-model="paineis.vendas.pedidos_bloqueados">
                <label class="switch-label" for="pedidos-bloqueados">Pedidos bloqueados</label>
              </div><!-- checkbox-group -->

              <div class="checkbox-group"> 
                <input 
                  type="checkbox" 
                  class="switch-input" 
                  id="pedidos-ultimo-dia" 
                  :change="verificarSwitchVendas()" 
                  :disabled="!permitirVisualizarDadosVendas()"
                  v-model="paineis.vendas.pedidos_ultimo_dia">
                <label class="switch-label" for="pedidos-ultimo-dia">Pedidos de hoje</label>
              </div><!-- checkbox-group -->

              <div class="checkbox-group">
                <input 
                  type="checkbox" 
                  class="switch-input"
                  id="pedidos-ultima-semana" 
                  :change="verificarSwitchVendas()"
                  :disabled="!permitirVisualizarDadosVendas()"
                  v-model="paineis.vendas.pedidos_ultima_semana">
                <label class="switch-label" for="pedidos-ultima-semana">Pedidos da última semana</label>
              </div><!-- checkbox-group -->

              <div class="checkbox-group">
                <input 
                  type="checkbox"
                  class="switch-input" 
                  id="pedidos-ultimo-mes" 
                  :change="verificarSwitchVendas()" 
                  :disabled="!permitirVisualizarDadosVendas()" 
                  v-model="paineis.vendas.pedidos_ultimo_mes">
                <label class="switch-label" for="pedidos-ultimo-mes">Pedidos do último mês</label>
              </div><!-- checkbox-group -->

              <div class="checkbox-group" >
                <input 
                  type="checkbox" 
                  class="switch-input" 
                  id="vendas_perdida" 
                  :change="verificarSwitchVendas()"
                  :disabled="!permitirVisualizarPedidosVencendo()"
                  v-model="paineis.vendas.vendas_perdida">
                <label class="switch-label" for="vendas_perdida">Vendas perdidas</label>
              </div><!-- checkbox-group -->

              <div class="checkbox-group" >
                <input 
                  type="checkbox" 
                  class="switch-input" 
                  id="produtos-em-promocao" 
                  :change="verificarSwitchVendas()"
                  :disabled="!permitirVisualizarProdutosEmPromocao()"
                  v-model="paineis.vendas.produtos_em_promocao">
                <label class="switch-label" for="produtos-em-promocao">Produtos em promoção</label>
              </div><!-- checkbox-group -->

              <div class="checkbox-group" >
                <input 
                  type="checkbox" 
                  class="switch-input" 
                  id="produtos-em-ponta-estoque"
                  :change="verificarSwitchVendas()" 
                  :disabled="!permitirVisualizarProdutosEmPontaEstoque()"
                  v-model="paineis.vendas.produtos_ponta_estoque">
                <label class="switch-label" for="produtos-em-ponta-estoque">Produtos em ponta de estoque</label>
              </div><!-- checkbox-group -->

              <div class="checkbox-group">
                <input 
                  type="checkbox" 
                  class="switch-input" 
                  :change="verificarSwitchVendas()"
                  id="produtos-cadastrados-ultimos-30dias"
                  :disabled="!permitirVisualizarProdutosCadastrado30Dias()"
                  v-model="paineis.vendas.produtos_cadastrados_ultimos_30_dias">
                <label class="switch-label" for="produtos-cadastrados-ultimos-30dias">Produtos cadastrados nos últimos 30 dias</label>
              </div><!-- checkbox-group -->

              <div class="checkbox-group">
                <input 
                  type="checkbox"
                  class="switch-input" 
                  id="produtos-comissao-especial" 
                  :change="verificarSwitchVendas()" 
                  :disabled="!permitirVisualizarProdutosComissaoEspecial()"
                  v-model="paineis.vendas.produtos_comissao_especial">
                <label class="switch-label" for="produtos-comissao-especial">Produtos em comissão especial</label>
              </div><!-- checkbox-group -->

            </div><!-- w3-col -->

            <div class="w3-col l4">
              <h5><b><i class="fas fa-dollar-sign"></i>  Compras e Entradas</b></h5>

              <button 
                @click="ativarComprasEntradas()"
                v-if="(
                  !ativar_todos_compras_entradas && 
                  (
                    permitirVisualizarCompraBloqueada() ||
                    permitirVisualizarComprasPendentesSemRestricao() || 
                    permitirVisualizarCompraPendenteSemNumeroFornecedor() ||
                    permitirVisualizarEntradasSemEstoqueConsolidado() ||
                    permitirVisualizarEntradasSemFinanceiroConsolidado() ||
                    permitirVisualizarXMLPendente5Dias() ||
                    permitirVisualizarEntradasBloqueadas() ||
                    permitirVisualizarNotasDevolucoesComprasPendentes()
                  )
                )" 
                class="w3-button w3-green w3-round-xxlarge w3-margin-bottom">
                <i class="fas fa-check"></i> Ativar todos
              </button>

              <button 
                @click="desativarComprasEntradas()" 
                v-if="!desativar_todos_compras_entradas"
                class="w3-button w3-red w3-round-xxlarge w3-margin-bottom">
                <i class="fas fa-times"></i> Desativar todos
              </button>

              <div class="checkbox-group">
                <input 
                  type="checkbox" 
                  class="switch-input"
                  id="pedidos-compra-bloqueados"
                  :change="verificarSwitchComprar()" 
                  :disabled="!permitirVisualizarCompraBloqueada()"
                  v-model="paineis.compras_entradas.pedidos_compra_bloqueados">
                <label class="switch-label" for="pedidos-compra-bloqueados">Pedidos de compra bloqueados</label>
              </div><!-- checkbox-group -->

              <div class="checkbox-group" >
                <input 
                  type="checkbox"
                  class="switch-input" 
                  id="pedidos-compra-pendentes-sem-restricao" 
                  :change="verificarSwitchComprar()" 
                  :disabled="!permitirVisualizarComprasPendentesSemRestricao()"
                  v-model="paineis.compras_entradas.pedidos_compra_pendentes_sem_restricao">
                <label class="switch-label" for="pedidos-compra-pendentes-sem-restricao">Pedidos de compra pendentes e sem restrição</label>
              </div><!-- checkbox-group -->

              <div class="checkbox-group">
                <input 
                  type="checkbox" 
                  class="switch-input"
                  id="pedidos-compra-pendentes-sem-nr-fornecedor"
                  :change="verificarSwitchComprar()" 
                  :disabled="!permitirVisualizarCompraPendenteSemNumeroFornecedor()"
                  v-model="paineis.compras_entradas.pedidos_compra_pendentes_sem_nr_fornecedor">
                <label class="switch-label" for="pedidos-compra-pendentes-sem-nr-fornecedor">Pedidos de compra pendentes sem número do fornecedor</label>
              </div><!-- checkbox-group -->

              <div class="checkbox-group" >
                <input
                  type="checkbox" 
                  class="switch-input" 
                  id="entradas-sem-estoque-consolidado"
                  :change="verificarSwitchComprar()"
                  :disabled="!permitirVisualizarEntradasSemEstoqueConsolidado()" 
                  v-model="paineis.compras_entradas.entradas_sem_estoque_consolidado">
                <label class="switch-label" for="entradas-sem-estoque-consolidado">Entradas sem estoque consolidado</label>
              </div><!-- checkbox-group -->

              <div class="checkbox-group">
                <input 
                  type="checkbox" 
                  class="switch-input" 
                  id="entradas-sem-financeiro-consolidado"
                  :change="verificarSwitchComprar()" 
                  :disabled="!permitirVisualizarEntradasSemFinanceiroConsolidado()" 
                  v-model="paineis.compras_entradas.entradas_sem_financeiro_consolidado">
                <label class="switch-label" for="entradas-sem-financeiro-consolidado">Entradas sem financeiro consolidado</label>
              </div><!-- checkbox-group -->

              <div class="checkbox-group">
                <input 
                  type="checkbox" 
                  class="switch-input"
                  id="xml-pendentes"
                  :change="verificarSwitchComprar()" 
                  :disabled="!permitirVisualizarXMLPendente5Dias()" 
                  v-model="paineis.compras_entradas.xml_pendentes">
                <label class="switch-label" for="xml-pendentes">XML pendentes há 5 dias</label>
              </div><!-- checkbox-group -->

              <div class="checkbox-group" >
                <input
                  type="checkbox"
                  class="switch-input" 
                  id="entradas-bloqueadas" 
                  :change="verificarSwitchComprar()"
                  :disabled="!permitirVisualizarEntradasBloqueadas()"
                  v-model="paineis.compras_entradas.entradas_bloqueadas">
                <label class="switch-label" for="entradas-bloqueadas">Entradas bloqueadas</label>
              </div><!-- checkbox-group -->

              <div class="checkbox-group" >
                <input
                  type="checkbox" 
                  class="switch-input" 
                  id="notas-devolucoes-compras-pendentes" 
                  :disabled="!permitirVisualizarNotasDevolucoesComprasPendentes()" 
                  v-model="paineis.compras_entradas.notas_devolucoes_compras_pendentes">
                <label class="switch-label" for="notas-devolucoes-compras-pendentes">Notas de dev. compras pendentes</label>
              </div><!-- checkbox-group -->

            </div><!-- w3-col -->

            <div class="w3-col l4" style="margin-top: 10px" v-if="autorizacoes.status_contabilidade != 'I'">
              <h5><b><i class="fa fa-calculator"></i>  Contabilidade </b></h5>

              <button 
                v-if="(
                  (!ativar_todos_contabilidade) && 
                  (permitirVisualizarContabilidade())
                )" 
                @click="ativarContabilidade()" 
                class="w3-button w3-green w3-round-xxlarge w3-margin-bottom">
                <i class="fas fa-check"></i> Ativar todos
              </button>

              <button 
                v-if="!desativar_todos_contabilidade" 
                @click="desativarContabilidade()"
                class="w3-button w3-red w3-round-xxlarge w3-margin-bottom">
                <i class="fas fa-times"></i> Desativar todos
              </button>

              <div class="checkbox-group">
                <input 
                  type="checkbox" 
                  class="switch-input"
                  :change="verificarSwitchContabilidade()" 
                  :disabled="!permitirVisualizarContabilidade()"
                  id="contas-contabeis-regras-provisionamento" 
                  v-model="paineis.contabilidade.contas_contabeis_regras_provisionamento">
                  
                <label 
                  class="switch-label" 
                  for="contas-contabeis-regras-provisionamento">
                  Contas contábeis com problemas na regra de provisionamento
                </label>
              </div><!-- checkbox-group -->
              
              <div class="checkbox-group">
                <input 
                  type="checkbox" 
                  class="switch-input"
                  :change="verificarSwitchContabilidade()" 
                  :disabled="!permitirVisualizarContabilidade()"
                  id="contas-contabeis-saldo-diferente-natureza" 
                  v-model="paineis.contabilidade.contas_contabeis_saldo_diferente_natureza">
                  
                <label 
                  class="switch-label" 
                  for="contas-contabeis-saldo-diferente-natureza">
                  Contas contábeis com saldo diferente da natureza (operação não permitida)
                </label>
              </div><!-- checkbox-group -->

            </div><!-- w3-col -->
          </div><!-- w3-block -->
        </div>

        <div 
          class="configuracoes-financeiro w3-row-padding w3-padding-large"
          v-if="autorizacoes.pedidos_vencendo == 'S' || 
          autorizacoes.usuario_gerente == 'S'">
          <div class="w3-col l4">
            <div class="data">
              <div class="w3-col l12">
                <label for="quantidade_dias"><strong>Quantidade de dias para vendas perdidas</strong></label>
                <input 
                  type="number" 
                  class="w3-input w3-border" 
                  name="quantidade_dias"
                  id="quantidade_dias"
                  style="max-width: 50%" 
                  v-model="paineis.vendas.quantidade_dias"/>
              </div><!-- w3-col -->
            </div><!-- data -->
          </div>
        </div>

      </div><!-- w3-col -->
      <div class="w3-block w3-row w3-margin-bottom" v-if="configuracoes_financeiro_totalmente_carregado">
        <div class="w3-container w3-center">
          <button class="w3-button w3-theme" @click="gravarConfiguracoes()"><i class="fa fa-check"></i> Gravar configurações</button>
          <button class="w3-button" @click="abrirOpcoesAvancadas()"><i class="fa fa-cog"></i></button>
        </div><!-- w3-container -->
      </div><!-- w3-block -->
    </div><!-- w3-block -->
    
    <div class="w3-block w3-row w3-margin-bottom" v-if="mostrar_opcoes_avancadas && configuracoes_financeiro_totalmente_carregado">
      <div class="w3-container w3-center">
        <button class="w3-button w3-gray w3-text-white" @click="limparLocalStorage()"><i class="fa fa-trash-alt"></i> Limpar banco de dados local</button>
      </div><!-- w3-container -->
    </div><!-- w3-block -->
  </div><!-- w3-main -->
</template>

<script>
  import moment from 'moment'
  import formatarValorMixin from '@/mixins/formatarValorMixin.js'
  import toastr from 'toastr'
  import RSessao from '@/components/Rest/RSessao.js'
  import store from '@/ambiente/store'

  export default {
    name: 'ConfiguracoesDashboard',
    components: {
      
    },
    mixins:[formatarValorMixin],
    data() {
      const self = this;
      return {
        autorizacoes: [],
        api: process.env.API,
        mostrar_opcoes_avancadas: false,
        marcar_todos: true,
        mostrar_tela: false,
        paineis: {
          vendas_vazio: true,
          compras_entradas_vazio: true,
          contabilidade_vazio: true,
          usuario_logado: null,
          vendas: {
            "pedidos_bloqueados": false,
            "pedidos_ultimo_dia": false,
            "pedidos_ultima_semana": false,
            "pedidos_ultimo_mes": false,
            "vendas_perdida": false,
            "produtos_em_promocao": false,
            "produtos_ponta_estoque": false,
            "produtos_cadastrados_ultimos_30_dias": false,
            "produtos_comissao_especial": false,
            "quantidade_dias": 7
          },
          compras_entradas: {
            "pedidos_compra_bloqueados": false,
            "pedidos_compra_pendentes_sem_restricao": false,
            "pedidos_compra_pendentes_sem_nr_fornecedor": false,
            "entradas_sem_estoque_consolidado": false,
            "entradas_sem_financeiro_consolidado": false,
            "xml_pendentes": false,
            "entradas_bloqueadas": false,
            "cancelar_pedido_compra": false,
            "notas_devolucoes_compras_pendentes": false
          },
          contabilidade: {
            "contas_contabeis_regras_provisionamento":false,
            "contas_contabeis_saldo_diferente_natureza":false,
          },
        },
        painelVendas: {},
        painelComprasEntradas: [],
        painelFinanceiro: [],
        filtro_contas: '',
        tipo_saldo: 'TSE',

        ativar_todos_vendas: false,
        desativar_todos_vendas: true,

        ativar_todos_compras_entradas: false,
        desativar_todos_compras_entradas: true,

        ativar_todos_financeiro: false,
        desativar_todos_financeiro: true,

        ativar_todos_contabilidade: false,
        desativar_todos_contabilidade: true,

        configuracoes_financeiro_totalmente_carregado: true,
      }
    },
    computed: {

      todasInformacoesCarregadas() {
        let obj = this.informacoes_carregadas;
        for(let item in obj)
          if(!obj[item]) return false;

        return true;
      },
      estaChecadoQualquerTipoDocumento: function() {
        let resultado = 'N';
        for(var item in this.tipo_documento_contas_pagar) {
          if(this.tipo_documento_contas_pagar[item] === true) {
            resultado = 'S';
            return resultado;
          }
        }

        return resultado;
      },
      existeFalseVendas: function() {
        let resultado = 'S';
        for(var item in this.paineis.vendas) {
          if(this.paineis.vendas[item] === true && item != 'quantidade_dias') {
            resultado = 'N';
            return resultado;
            break;
          }
        }

        return resultado;
      },
      existeFalseComprasEntradas: function() {
        let resultado = 'S';
        for(var item in this.paineis.compras_entradas) {
          if(this.paineis.compras_entradas[item] === true) {
            resultado = 'N';
            return resultado;
            break;
          }
        }

        return resultado;
      },
      existeFalseContabilidade: function() {
        let resultado = 'S';
        for(var item in this.paineis.contabilidade) {
          if(this.paineis.contabilidade[item] === true) {
            resultado = 'N';
            return resultado;
            break;
          }
        }

        return resultado;
      },
    },
    methods: {
      abrirModal(){
        this.mostrar_tela = true;
      },

      verificarSwitchVendas() {
        if 
          (
            this.paineis.vendas.pedidos_bloqueados == true || 
            this.paineis.vendas.pedidos_ultima_semana == true || 
            this.paineis.vendas.pedidos_ultimo_dia == true ||
            this.paineis.vendas.pedidos_ultimo_mes == true  || 
            this.paineis.vendas.produtos_cadastrados_ultimos_30_dias == true ||
            this.paineis.vendas.produtos_comissao_especial == true  ||  
            this.paineis.vendas.produtos_em_promocao == true ||
            this.paineis.vendas.produtos_ponta_estoque == true || 
            this.paineis.vendas.vendas_perdida == true
          ) 
        {
          this.ativar_todos_vendas = true;
        } else {
          this.ativar_todos_vendas = false;
        }
      },

      verificarSwitchComprar() {
        if 
          ( 
            this.paineis.compras_entradas.pedidos_compra_bloqueados == true || 
            this.paineis.compras_entradas.pedidos_compra_pendentes_sem_nr_fornecedor == true ||
            this.paineis.compras_entradas.entradas_sem_estoque_consolidado == true || 
            this.paineis.compras_entradas.entradas_sem_financeiro_consolidado == true  ||
            this.paineis.compras_entradas.xml_pendentes == true ||
            this.paineis.compras_entradas.entradas_bloqueadas == true
          )
        {
          this.desativar_todos_compras_entradas = false;
          this.ativar_todos_compras_entradas = true;
        } else {
          this.desativar_todos_compras_entradas = true;
          this.ativar_todos_compras_entradas = false;
        }
      },

      verificarSwitchContabilidade() {
        if 
          (
            this.paineis.contabilidade.contas_contabeis_regras_provisionamento == true || 
            this.paineis.contabilidade.contas_contabeis_saldo_diferente_natureza == true
          ) 
        {
          this.ativar_todos_contabilidade = true;
          this.desativar_todos_contabilidade = false;
        } else {
          this.desativar_todos_contabilidade = true;
          this.ativar_todos_contabilidade = false;
        }
      },

      buscarValorTipoDocumentoChecado: function(tipo_documento) {
        if (this.tipo_documento_contas_pagar.tipo_documento === true) {
          return 'checked="checked"';
        } else {
          return '';
        }
      },

      permitirVisualizarPedidosBloqueados(){
        return (
          (this.autorizacoes.pedidos_bloqueados == 'S') || 
          (this.autorizacoes.usuario_gerente == 'S')
        );
      },

      permitirVisualizarDadosVendas(){
        return (
          (this.autorizacoes.painel_vendas == 'S') || 
          (this.autorizacoes.usuario_gerente == 'S')
        );
      },

      permitirVisualizarPedidosVencendo(){
        return (
          (this.autorizacoes.pedidos_vencendo == 'S') ||
          (this.autorizacoes.usuario_gerente == 'S')
        );
      },

      permitirVisualizarProdutosEmPromocao(){
        return (
          (this.autorizacoes.produtos_em_promocao == 'S') || 
          (this.autorizacoes.usuario_gerente == 'S')
        );
      },

      permitirVisualizarProdutosEmPontaEstoque(){
        return (
          (this.autorizacoes.produto_ponta_estoque == 'S') || 
          (this.autorizacoes.usuario_gerente == 'S')
        );
      },

      permitirVisualizarProdutosCadastrado30Dias(){
        return (
          (this.autorizacoes.produto_cadastrado_30_dias == 'S') || 
          (this.autorizacoes.usuario_gerente == 'S')
        );
      },

      permitirVisualizarProdutosComissaoEspecial(){
        return (
          (this.autorizacoes.produto_comissao_especial == 'S') || 
          (this.autorizacoes.usuario_gerente == 'S')
        );
      },

      ativarVendas() {
        if (this.permitirVisualizarPedidosBloqueados()){
          this.paineis.vendas.pedidos_bloqueados = true;
        }

        if (this.permitirVisualizarPedidosVencendo()){
          this.paineis.vendas.vendas_perdida = true;
        }

        if (this.permitirVisualizarProdutosEmPromocao()){
          this.paineis.vendas.produtos_em_promocao = true;
        }

        if (this.permitirVisualizarProdutosEmPontaEstoque()){
          this.paineis.vendas.produtos_ponta_estoque = true;
        }

        if (this.permitirVisualizarProdutosCadastrado30Dias()){
          this.paineis.vendas.produtos_cadastrados_ultimos_30_dias = true;
        }

        if (this.permitirVisualizarProdutosComissaoEspecial()){
          this.paineis.vendas.produtos_comissao_especial = true;
        }

        if (this.permitirVisualizarDadosVendas()){
          this.paineis.vendas.pedidos_ultimo_dia = true;
          this.paineis.vendas.pedidos_ultima_semana = true;
          this.paineis.vendas.pedidos_ultimo_mes = true;
        }

        this.desativar_todos_vendas = false;
        this.ativar_todos_vendas = true;
      },

      desativarVendas(){
        for(var item in this.paineis.vendas) {
          if(item != 'quantidade_dias'){
            this.paineis.vendas[item] = false;
          }
        }
        
        this.ativar_todos_vendas = false;
        this.desativar_todos_vendas = true;
      },

      permitirVisualizarCompraBloqueada(){
        return (
          (this.autorizacoes.compras_bloqueadas == 'S') || 
          (this.autorizacoes.usuario_gerente == 'S')
        );
      },

      permitirVisualizarComprasPendentesSemRestricao(){
        return (
          (this.autorizacoes.compras_pendentes_sem_restricao == 'S') || 
          (this.autorizacoes.usuario_gerente == 'S')
        );
      },

      permitirVisualizarCompraPendenteSemNumeroFornecedor(){
        return (
          (this.autorizacoes.pedidos_sem_numero_fornecedor == 'S') || 
          (this.autorizacoes.usuario_gerente == 'S')
        );
      },

      permitirVisualizarEntradasSemEstoqueConsolidado(){
        return (
          (this.autorizacoes.entrada_sem_estoque_consolidado == 'S') || 
          (this.autorizacoes.usuario_gerente == 'S')
        );
      },

      permitirVisualizarEntradasSemFinanceiroConsolidado(){
        return (
          (this.autorizacoes.entrada_sem_financeiro_consolidado == 'S') || 
          (this.autorizacoes.usuario_gerente == 'S')
        );
      },

      permitirVisualizarXMLPendente5Dias(){
        return (
          (this.autorizacoes.xml_pendentes_cinco_dias == 'S') || 
          (this.autorizacoes.usuario_gerente == 'S')
        );
      },

      permitirVisualizarEntradasBloqueadas(){
        return (
          (this.autorizacoes.entradas_bloqueada == 'S') || 
          (this.autorizacoes.usuario_gerente == 'S')
        );
      },

      permitirVisualizarNotasDevolucoesComprasPendentes(){
        return (
          (this.autorizacoes.notas_devolucoes_compras_pendentes == 'S') || 
          (this.autorizacoes.usuario_gerente == 'S')
        );
      },

      ativarComprasEntradas() {
        if (this.permitirVisualizarCompraBloqueada()){
          this.paineis.compras_entradas.pedidos_compra_bloqueados = true;
        }

        if (this.permitirVisualizarComprasPendentesSemRestricao()){
          this.paineis.compras_entradas.pedidos_compra_pendentes_sem_restricao = true;
        }

        if (this.permitirVisualizarCompraPendenteSemNumeroFornecedor()){
          this.paineis.compras_entradas.pedidos_compra_pendentes_sem_nr_fornecedor = true;
        }

        if (this.permitirVisualizarEntradasSemEstoqueConsolidado()){
          this.paineis.compras_entradas.entradas_sem_estoque_consolidado = true;
        }

        if (this.permitirVisualizarEntradasSemFinanceiroConsolidado()){
          this.paineis.compras_entradas.entradas_sem_financeiro_consolidado = true;
        }

        if (this.permitirVisualizarXMLPendente5Dias()){
          this.paineis.compras_entradas.xml_pendentes = true;
        }

        if (this.permitirVisualizarEntradasBloqueadas()){
          this.paineis.compras_entradas.entradas_bloqueadas = true;
        }

        if (this.permitirVisualizarNotasDevolucoesComprasPendentes()){
          this.paineis.compras_entradas.notas_devolucoes_compras_pendentes = true;
        }

        this.desativar_todos_compras_entradas = false;
        this.ativar_todos_compras_entradas = true;
      },

      desativarComprasEntradas() {
        for(var item in this.paineis.compras_entradas) {
          this.paineis.compras_entradas[item] = false;
        }

        this.ativar_todos_compras_entradas = false;
        this.desativar_todos_compras_entradas = true;
      },

      permitirVisualizarContabilidade(){
        return (
          (this.autorizacoes.contas_contabeis_criticas == 'S') ||
          (this.autorizacoes.usuario_gerente == 'S')
        );
      },

      ativarContabilidade(){
        if (this.permitirVisualizarContabilidade()) {
          this.paineis.contabilidade.contas_contabeis_saldo_diferente_natureza = true;
          this.paineis.contabilidade.contas_contabeis_regras_provisionamento = true;
        }

        this.desativar_todos_contabilidade = false;
        this.ativar_todos_contabilidade = true;
      },

      desativarContabilidade(){
        for(var item in this.paineis.contabilidade) {
          this.paineis.contabilidade[item] = false;
        }

        this.ativar_todos_contabilidade = false;
        this.desativar_todos_contabilidade = true;
      },

      async gravarConfiguracoes() {
        if
          (
            this.existeFalseVendas === 'S' &&
            this.existeFalseComprasEntradas === 'S' &&
            this.existeFalseContabilidade === 'S'
          )
        {
          toastr.error('Pelo menos um card deve ser habilitado!');
          return;
        }

        this.paineis.vendas_vazio = true;
        this.paineis.compras_entradas_vazio = true;
        this.paineis.contabilidade_vazio = true;

        if (this.existeFalseVendas != 'S'){
          this.paineis.vendas_vazio = false;
        }

        if (this.existeFalseComprasEntradas != 'S') {
          this.paineis.compras_entradas_vazio = false;
        }

        if (this.existeFalseContabilidade != 'S') {
          this.paineis.contabilidade_vazio = false;
        }

        await localStorage.setItem("paineis", JSON.stringify(this.paineis))

        swal("Configurações gravadas com sucesso!", 'O que deseja fazer agora?', 'success', {
          buttons: {
            nao: "Permanecer em configurações",
            sim: "Ir para o dashboard",
          },
        })
        .then((value) => {
          switch (value) {
            case "sim":
              this.mostrar_tela = false;
              this.$emit('carregarDados');
              window.scrollTo(0, 0); 
          }
        });
      },

      async buscarAutorizacoes(usuario_id) {
        try {
          let retorno
          retorno = await RSessao.buscarAutorizacoesDashboard(this.axios);
          
          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }
          
          this.configuracoes_financeiro_totalmente_carregado = true;
          this.autorizacoes = retorno.dados.autorizacoes_painel['0'];
        } catch (error) {
          console.log(error);
          return;
        }
      },

      async buscarInformacoesVisibilidade(usuario_id) {
        let paineis = await JSON.parse(localStorage.getItem('paineis'))
        
        if (paineis && (usuario_id === paineis.usuario_logado)) {
          this.paineis = await JSON.parse(localStorage.getItem('paineis'))
        } else {
          this.paineis = this.paineis;
        }
      },

      async verificarPainelVazioBotaoMarcarTodos(){
        let paineis = await JSON.parse(localStorage.getItem('paineis'));
        
        if (!await RSessao.carregouSessao()) {
          await RSessao.buscarDadosCarregarSessao(this.axios);
        }

        let usuario_logado = await JSON.parse(JSON.stringify(store.state.usuario_logado));
        
        if (paineis) {

          if(paineis.usuario_logado === usuario_logado.funcionario_id) {

            if (!paineis.vendas_vazio){
              this.ativar_todos_vendas = true;
              this.desativar_todos_vendas = false;
            }

            if (!paineis.compras_entradas_vazio){
              this.ativar_todos_compras_entradas = true;
              this.desativar_todos_compras_entradas = false;
            }

            if(!paineis.contabilidade_vazio){
              this.ativar_todos_contabilidade = true;
              this.desativar_todos_contabilidade = false;
            }
          }
        }
      },

      abrirOpcoesAvancadas: function() {
        this.mostrar_opcoes_avancadas = !this.mostrar_opcoes_avancadas
      },

      limparLocalStorage: function() {
        swal("Deseja realmente limpar o banco de dados local?", {
          buttons: {
            nao: "Não",
            sim: "Sim",
          },
        })
        .then(async (value) => {
          switch (value) {
            case "sim":
              await localStorage.removeItem('paineis');
              location.reload();
          }
        });
      }
    },

    created() {
      this.configuracoes_financeiro_totalmente_carregado = false;
    },
    
    async mounted(){
      await this.verificarPainelVazioBotaoMarcarTodos();

      if (!await RSessao.carregouSessao()) {
        await RSessao.buscarDadosCarregarSessao(this.axios);
      }
      
      let usuario_logado = await JSON.parse(JSON.stringify(store.state.usuario_logado));
      let paineis = await JSON.parse(localStorage.getItem('paineis'))
      
      if (paineis && (paineis.usuario_logado === usuario_logado.funcionario_id)){

        if (!paineis.vendas_vazio){
          this.ativar_todos_vendas = true;
          this.desativar_todos_vendas = false;
        }
        
        if (!paineis.compras_entradas_vazio){
          this.ativar_todos_compras_entradas = true;
          this.desativar_todos_compras_entradas = false;
        }
        
        if(!paineis.contabilidade_vazio){
          this.ativar_todos_contabilidade = true;
          this.desativar_todos_contabilidade = false;
        }
      }

      await this.buscarAutorizacoes(usuario_logado.funcionario_id);
      this.paineis.usuario_logado = usuario_logado.funcionario_id;
      await this.buscarInformacoesVisibilidade(usuario_logado.funcionario_id);
    }
  }
</script>

<style scoped>
  .box_configuracoes {
    max-height: 280px;
    overflow: auto;
    margin-bottom: 30px;
    float: left;
    width: 100%;
    clear: both;
  }

  .grupo-contas-pagar > .w3-col:not(:last-child) {
    margin-bottom: 5px
  }

  .opcoes_avancadas {
    margin-top: 20px;
    cursor: pointer;
    text-decoration: underline;
  }

  .checkbox-group label {
    cursor: pointer;
  }

  .switch-input {
    display: none;
  }
  .switch-label {
    position: relative;
    display: inline-block;
    min-width: 112px;
    cursor: pointer;
    text-align: left;
    padding: 10px 0 10px 44px;
  }
  .switch-label:before, .switch-label:after {
    content: "";
    position: absolute;
    margin: 0;
    outline: 0;
    top: 50%;
    -ms-transform: translate(0, -50%);
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  .switch-label:before {
    left: 1px;
    width: 34px;
    height: 14px;
    background-color: #9E9E9E;
    border-radius: 8px;
  }
  .switch-label:after {
    left: 0;
    width: 20px;
    height: 20px;
    background-color: #FAFAFA;
    border-radius: 50%;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.14), 0 2px 2px 0 rgba(0, 0, 0, 0.098), 0 1px 5px 0 rgba(0, 0, 0, 0.084);
  }
  .switch-label .toggle--on {
    display: none;
  }
  .switch-label .toggle--off {
    display: inline-block;
  }
  .switch-input:checked + .switch-label:before {
    background-color: #34ACFE;
  }
  .switch-input:checked + .switch-label:after {
    background-color: #0080d6;
    -ms-transform: translate(80%, -50%);
    -webkit-transform: translate(80%, -50%);
    transform: translate(80%, -50%);
  }

  @media(max-width: 950px) {
    .w3-row-padding {
      padding: 0
    }

    input#quantidade_dias {
      max-width: 100% !important;
      margin-bottom: 10px
    }

    select#tipo_saldo {
      margin-bottom: 20px
    }
  }

  #quantidade_dias{
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ConfiguracoesDashboard.vue